import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AllLeadsDataService } from '../../services/all-leads-data.service';
import { AppPermissionService } from '@core/services/app-permission.service';
import Swal from 'sweetalert2';
@Component({
  templateUrl: './assign-target.component.html',
  styleUrls: ['./assign-target.component.scss']
})
export class AssignTargetDialogComponent implements OnInit, OnDestroy {

  @ViewChildren('focusfield') focusfield: QueryList<ElementRef>;
  form: FormGroup;
  telemarketerDropdownSettings = {};
  telemarketerDropdownList = [];
  telemarketerSelectedItems = [];
  private subscription = new Subscription();
  refreshStatus: boolean;
  buttonLoading = false;

  // permissions
  canAssignLead: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { leadID: any },
    public dialogRef: MatDialogRef<AssignTargetDialogComponent>,
    private allLeadsDataService: AllLeadsDataService,
    private appPermissionService: AppPermissionService,
  ) { }

  ngOnInit() {
    const apSub = this.appPermissionService.getAppPermissions().subscribe(appPermissions => {
      this.canAssignLead = appPermissions.assign_leads;
    });

    this.formInit();
    this.allLeadsDataService.getTelemarketerList(`?settings_currency_id=${this.data.leadID.settings_currency_id}`).subscribe(res => {
      this.telemarketerDropdownList = res;
    });

    this.telemarketerDropdownSettings = {
      singleSelection: true,
      text: 'Please Select',
      maxHeight: 300,
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'username',
      labelKey: 'username',
      lazyLoading: true,
      noDataLabel: '',
      showCheckbox: false,
      autoPosition: false
    };
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.onRefresh();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.buttonLoading = true;
    this.form.setErrors({ 'invalid': true });
    const data = {
      ...this.form.value
    };
    Object.keys(data).forEach((key) => (data[key] == null || data[key] === '') && delete data[key]);

    var telemarketerUsername = this.telemarketerDropdownList.find(item => item.id === data['telemarketer_id'])?.username || '';
    data['lead_ids'] = [data['lead_ids']];
    Swal.fire({
    title: 'Assign Lead Confirmation',
    html: `
    <p>Are you sure you want to assign <b>${this.data.leadID.initial_lead_type == 0 ? this.data.leadID.mobile : this.data.leadID.username}</b> to <b>${telemarketerUsername}</b>?</p>
    <div style="margin-top: 1rem;">
      <p style="margin-bottom: 0;">Current Status: <span style="color: #1db4ff; font-weight: bold;">Open</span></p>
      <p>New Status: <span style="color: #0abb87; font-weight: bold;">Active</span></p>
    </div>
    `, 
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes',
    reverseButtons: true,
    }).then((resp) => {
        if (resp.isConfirmed) {
        this.subscription = this.allLeadsDataService.assignTarget(data).pipe(
            tap(() => {
            this.buttonLoading = false;
            this.form.setErrors(null);
            this.dialogRef.close(true);
            }),
            catchError((error) => {
            this.buttonLoading = false;
            this.form.setErrors(null);
            throw error;
            })
        ).subscribe();
        } else if (resp.isDismissed) {
        this.buttonLoading = false;
        this.form.setErrors(null);
        }
    });
    
    this.refreshStatus = true;
  }

  onRefresh() {
    if (this.refreshStatus === true) {
      this.dialogRef.close(true);
    }
  }

  private formInit() {
    this.form = new FormGroup({
      settings_currency_id: new FormControl(this.data.leadID.settings_currency_id),
      telemarketer_id: new FormControl(null, [Validators.required]),
      initial_lead_type: new FormControl(0, [Validators.required]), // always pass as 0 let API to use lead id to assign the lead
      lead_ids: new FormControl(this.data.leadID.lead_id, [Validators.required])
    });
  }
}
